export const faceSwap = {
    // 页面标题和基本文本
    title: 'AI捏脸',
    subtitle: '智能人脸替换工具',
    description: '通过选项配置和图片上传，自定义生成和调整人物形象',
    
    // 主要功能标签
    tabs: {
      textToImage: '文生图',
      imageToImage: '图生图'
    },
    
    // 按钮文本
    buttons: {
      generate: '生成',
      download: '下载',
      preview: '预览',
      upload: '上传图片',
      clear: '清空',
      save: '保存',
      cancel: '取消',
      confirm: '确认',
      reset: '重置',
      random: '随机选择',
      clearAll: '全部清除',
      backToWorkbench: '返回工作台'
    },
    
    // 状态文本
    status: {
      generating: '生成中...',
      uploading: '上传中...',
      processing: '处理中...',
      completed: '完成',
      failed: '失败',
      ready: '就绪'
    },
    
    // 消息提示
    messages: {
      uploadSuccess: '上传成功',
      uploadFailed: '上传失败',
      generateSuccess: '生成成功',
      generationSuccess: '生成成功',
      generateFailed: '生成失败',
      invalidFile: '无效的文件格式',
      fileTooLarge: '文件过大',
      networkError: '网络错误',
      generationStarted: '生成已开始',
      generationStatusError: '生成状态错误',
      generationTimeout: '生成超时',
      queryStatusFailed: '查询状态失败',
      uploadFirst: '请先上传图片',
      generateIdError: '生成ID错误',
      downloadFailed: '下载图片失败'
    },
    
    // 提示词输入
    prompt: {
      label: '提示词',
      placeholder: '请输入描述文字...',
      help: '详细描述您想要的人物特征'
    },
    
    // 上传区域
    upload: {
      title: '上传图片',
      dragText: '拖拽图片到此处',
      clickText: '或点击选择文件',
      supportedFormats: '支持 JPG、PNG 格式',
      maxSize: '最大 10MB',
      placeholder: '请上传图片'
    },
    
    // 结果展示
    result: {
      title: '生成结果',
      original: '原图',
      generated: '生成图',
      noResult: '暂无结果',
      placeholder: '生成的图片将在这里显示'
    },

    // 预览模态框
    preview: {
      title: '图片预览',
      imageAlt: '预览图片'
    },
    
    // 分类定义
    categories: {
      role: '角色',
      photography: '摄影',
      style: '风格',
      environment: '环境'
    },

    // 选项相关
    options: {
      // Intentionally left empty as per TC file structure which ended abruptly in read
    }
};
